import React from 'react';
import { View, StyleSheet, ImageBackground } from 'react-native';
import { MyEventModel } from '../../types';
import SuccessBG from '../../assets/images/success-bg.png';
import { BText } from '../BText';
import { themeConfig } from '../../styles/themeConfig';
import { RegistrationDetail } from './RegistrationDetails';

type props = {
  event: MyEventModel;
  onClose: any;
};

export const RegisteredSuccess = ({ event, onClose }: props) => {
  return (
    <View style={styles.container}>
      <View style={styles.infoContainer}>
        <ImageBackground source={{ uri: SuccessBG }} resizeMode="cover" style={styles.infoBgImg}>
          <View style={styles.infoContent}>
            <BText style={[styles.infoTitle, styles.color, styles.bold]}>Registration Saved</BText>
            <View style={styles.infoDetails}>
              <BText style={[styles.infoDetailText, styles.color, styles.bold]}>You&apos;re all set!</BText>
              <BText style={[styles.infoDetailText, styles.color]}>
                You reserved 1 tickets to {event.event.eventName}. You will receive a confirmation email within 24
                hours.
              </BText>
            </View>
          </View>
        </ImageBackground>
      </View>
      <View>
        <RegistrationDetail event={event} onClose={onClose} showClose={true} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    zIndex: 10,
    margin: 'auto',
    width: 343,
  },
  infoContainer: {
    position: 'relative',
    width: '100%',
    height: 356,
    marginBottom: 10,
    borderRadius: themeConfig.settings.borderRadius,
    backgroundColor: themeConfig.colors.blue,

    paddingHorizontal: 16,
    paddingTop: 32,
    paddingBottom: 0,
  },
  infoBgImg: {
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  color: {
    color: themeConfig.colors.white,
  },
  bold: {
    fontWeight: 'bold',
  },
  infoContent: {
    position: 'absolute',
    top: 0,
    flex: 1,
  },
  infoTitle: {
    fontSize: 20,
    marginBottom: 55,
  },
  infoDetails: {},
  infoDetailText: {
    fontSize: 16,
    paddingBottom: 16,
  },
});
